// i18n strings for the Order Recall widget. Supported: en, nl, fr.
export const SUPPORTED_LANGS = ["en", "nl", "fr"];

export const translations = {
  en: {
    landing: {
      serviceLabel: "Order Recall Service",
      customerService: "Customer Service",
      heroTitle: "Need to recall an order?",
      heroSubtitle:
        "Enter your order number, postal code and email address. We'll verify your order and confirm your recall request by email within minutes.",
      recallButton: "Recall an order",
      feature1Title: "Verified securely",
      feature1Desc: "We match your order number with the postal code on file.",
      feature2Title: "Instant confirmation",
      feature2Desc: "You receive a confirmation email the moment we log your request.",
      feature3Title: "Fully registered",
      feature3Desc: "Every recall is registered with our service team for follow-up.",
      sampleOrdersLabel: "Try these sample orders",
    },
    modal: {
      badge: "Order Recall",
      title: "Recall your order",
      subtitle: "Enter your details below. We'll verify your order before you submit the recall.",
      orderLabel: "Order number",
      orderPlaceholder: "e.g., ORD-10001",
      orderRequired: "Order number is required.",
      postalLabel: "Postal code",
      postalPlaceholder: "e.g., 1011AB",
      postalRequired: "Postal code is required.",
      emailLabel: "Email address",
      emailPlaceholder: "e.g., you@email.com",
      emailInvalid: "Please enter a valid email address.",
      verifyButton: "Verify order",
      recallButton: "Recall order",
      orderVerified: "Order verified",
      warning14:
        "This order is older than 14 days. You can still submit a recall request, but processing may require additional review.",
      reasonNotFound:
        "We could not find an order matching this order number and postal code. Please check your details and try again.",
      reasonCancelled: "This order has already been cancelled and cannot be recalled.",
      reasonCompany: "This order was placed by a company and is not eligible for a recall.",
      successTitle: "Recall request received",
      successBodyPre: "We've registered your recall and sent a confirmation email to",
      successBodyPost: ". Our service team will follow up shortly.",
      closeButton: "Close",
      genericError: "Something went wrong while verifying your order. Please try again.",
      submitError: "Could not submit the recall request. Please try again.",
    },
  },
  nl: {
    landing: {
      serviceLabel: "Bestelling terugroepen",
      customerService: "Klantenservice",
      heroTitle: "Wilt u een bestelling terugroepen?",
      heroSubtitle:
        "Vul uw bestelnummer, postcode en e-mailadres in. We controleren uw bestelling en bevestigen uw terugroepverzoek binnen enkele minuten per e-mail.",
      recallButton: "Bestelling terugroepen",
      feature1Title: "Veilig geverifieerd",
      feature1Desc: "We koppelen uw bestelnummer aan de geregistreerde postcode.",
      feature2Title: "Directe bevestiging",
      feature2Desc: "U ontvangt een bevestigingsmail zodra we uw verzoek registreren.",
      feature3Title: "Volledig geregistreerd",
      feature3Desc: "Elke terugroeping wordt geregistreerd bij ons serviceteam voor opvolging.",
      sampleOrdersLabel: "Probeer deze voorbeeldbestellingen",
    },
    modal: {
      badge: "Bestelling terugroepen",
      title: "Roep uw bestelling terug",
      subtitle:
        "Vul hieronder uw gegevens in. We controleren uw bestelling voordat u de terugroeping indient.",
      orderLabel: "Bestelnummer",
      orderPlaceholder: "bijv. ORD-10001",
      orderRequired: "Bestelnummer is verplicht.",
      postalLabel: "Postcode",
      postalPlaceholder: "bijv. 1011AB",
      postalRequired: "Postcode is verplicht.",
      emailLabel: "E-mailadres",
      emailPlaceholder: "bijv. jij@email.com",
      emailInvalid: "Voer een geldig e-mailadres in.",
      verifyButton: "Bestelling controleren",
      recallButton: "Bestelling terugroepen",
      orderVerified: "Bestelling geverifieerd",
      warning14:
        "Deze bestelling is ouder dan 14 dagen. U kunt nog steeds een terugroepverzoek indienen, maar de verwerking kan extra controle vereisen.",
      reasonNotFound:
        "We konden geen bestelling vinden met dit bestelnummer en deze postcode. Controleer uw gegevens en probeer het opnieuw.",
      reasonCancelled: "Deze bestelling is al geannuleerd en kan niet worden teruggeroepen.",
      reasonCompany: "Deze bestelling is geplaatst door een bedrijf en komt niet in aanmerking voor terugroeping.",
      successTitle: "Terugroepverzoek ontvangen",
      successBodyPre: "We hebben uw terugroeping geregistreerd en een bevestigingsmail gestuurd naar",
      successBodyPost: ". Ons serviceteam neemt binnenkort contact met u op.",
      closeButton: "Sluiten",
      genericError: "Er is iets misgegaan bij het controleren van uw bestelling. Probeer het opnieuw.",
      submitError: "Het terugroepverzoek kon niet worden verzonden. Probeer het opnieuw.",
    },
  },
  fr: {
    landing: {
      serviceLabel: "Service de rappel de commande",
      customerService: "Service client",
      heroTitle: "Besoin de rappeler une commande ?",
      heroSubtitle:
        "Saisissez votre numéro de commande, votre code postal et votre adresse e-mail. Nous vérifierons votre commande et confirmerons votre demande de rappel par e-mail en quelques minutes.",
      recallButton: "Rappeler une commande",
      feature1Title: "Vérifié en toute sécurité",
      feature1Desc: "Nous associons votre numéro de commande au code postal enregistré.",
      feature2Title: "Confirmation instantanée",
      feature2Desc: "Vous recevez un e-mail de confirmation dès que nous enregistrons votre demande.",
      feature3Title: "Entièrement enregistré",
      feature3Desc: "Chaque rappel est enregistré auprès de notre équipe de service pour suivi.",
      sampleOrdersLabel: "Essayez ces commandes d'exemple",
    },
    modal: {
      badge: "Rappel de commande",
      title: "Rappelez votre commande",
      subtitle:
        "Saisissez vos informations ci-dessous. Nous vérifierons votre commande avant l'envoi de la demande de rappel.",
      orderLabel: "Numéro de commande",
      orderPlaceholder: "ex. ORD-10001",
      orderRequired: "Le numéro de commande est obligatoire.",
      postalLabel: "Code postal",
      postalPlaceholder: "ex. 1011AB",
      postalRequired: "Le code postal est obligatoire.",
      emailLabel: "Adresse e-mail",
      emailPlaceholder: "ex. vous@email.com",
      emailInvalid: "Veuillez saisir une adresse e-mail valide.",
      verifyButton: "Vérifier la commande",
      recallButton: "Rappeler la commande",
      orderVerified: "Commande vérifiée",
      warning14:
        "Cette commande date de plus de 14 jours. Vous pouvez toujours soumettre une demande de rappel, mais son traitement peut nécessiter une vérification supplémentaire.",
      reasonNotFound:
        "Nous n'avons trouvé aucune commande correspondant à ce numéro de commande et à ce code postal. Veuillez vérifier vos informations et réessayer.",
      reasonCancelled: "Cette commande a déjà été annulée et ne peut pas être rappelée.",
      reasonCompany: "Cette commande a été passée par une entreprise et n'est pas éligible à un rappel.",
      successTitle: "Demande de rappel reçue",
      successBodyPre: "Nous avons enregistré votre rappel et envoyé un e-mail de confirmation à",
      successBodyPost: ". Notre équipe de service vous contactera prochainement.",
      closeButton: "Fermer",
      genericError: "Une erreur s'est produite lors de la vérification de votre commande. Veuillez réessayer.",
      submitError: "Impossible d'envoyer la demande de rappel. Veuillez réessayer.",
    },
  },
};

// Detect active language: ?lang= param -> <html lang> -> browser -> default en.
export function detectLang() {
  try {
    const params = new URLSearchParams(window.location.search);
    const q = (params.get("lang") || "").slice(0, 2).toLowerCase();
    if (SUPPORTED_LANGS.includes(q)) return q;
    const htmlLang = (document.documentElement.lang || "").slice(0, 2).toLowerCase();
    if (SUPPORTED_LANGS.includes(htmlLang)) return htmlLang;
    const nav = (navigator.language || "").slice(0, 2).toLowerCase();
    if (SUPPORTED_LANGS.includes(nav)) return nav;
  } catch (e) {
    // ignore
  }
  return "en";
}
